import React, { useEffect, useState } from 'react';
import { TComputeStepParams } from '../../types';
import "./Ops.css";
import { EDataSource, ESupportedOperations } from '../../types/Operations';

export default function Ops(props: {
    key: number,
    index: number,
    onChange: (index: number, item: TComputeStepParams) => void,
    removeOperation: (index: number) => void,
    values: TComputeStepParams,
}) {

    const [err, setErr] = useState<string>('');
    const [state, setState] = useState<TComputeStepParams>(props.values);

    useEffect(() => {
        props.onChange(props.index, state);
    }, [state]);

    useEffect(() => {
        setState(props.values);
    }, [props.values]);

    return (<div className='call-params-container'>
        <div className='rightAlignedRow'>
            <div>Calculation # {props.index}</div>
        </div>
        <div className='orderRow'>
            <span className='labelCaption'>Operation {props.index}:</span>
            <span className='plaseholderLarge'></span>
            <select
                value={state.operation}
                onChange={e => setState({ ...state, operation: parseInt(e?.target.value) })}
            >
                <option value={ESupportedOperations.add}> Add ( + )</option>
                <option value={ESupportedOperations.sub}>Subtract ( - )</option>
                <option value={ESupportedOperations.mul}>Multiply ( * )</option>
                <option value={ESupportedOperations.div}>Divide   ( / )</option>
                <option value={ESupportedOperations.eq}>Equals    ( == )</option>
                <option value={ESupportedOperations.gt}>{"Greater Than ( > )"}</option>
                <option value={ESupportedOperations.neq}>Not Equals  ( != )</option>
            </select>
            <span className='placeholderSmall'></span>
            <button
                onClick={() => props.removeOperation(props.index)}
            >
                Remove Step
            </button>
        </div>
        <div className='orderRow'>
            <span className='labelCaption'>Parameter A:</span>
            <label className='miniLabel'>Source: </label>
            <select
                value={state.sourseOne}
                onChange={e => setState({ ...state, sourseOne: parseInt(e?.target.value) })}
            >
                <option value={EDataSource.Requests}>Requests</option>
                <option value={EDataSource.Calculations}>Calculations</option>
            </select>
            <label className='miniLabel'>Index: </label>
            <input
                className='width100'
                type="number"
                value={state.itemOne}
                onChange={e => setState({ ...state, itemOne: parseInt(e?.target.value) })}
            />
        </div>
        <div className='orderRow'>
            <span className='labelCaption'>Parameter B:</span>
            <label className='miniLabel'>Source: </label>
            <select
                value={state.sourseTwo}
                onChange={e => setState({ ...state, sourseTwo: parseInt(e?.target.value) })}>
                <option value={EDataSource.Requests}>Requests</option>
                <option value={EDataSource.Calculations}>Calculations</option>
            </select>
            <label className='miniLabel'>Index: </label>
            <input
                className='width100'
                type="number"
                value={state.itemTwo}
                onChange={e => setState({ ...state, itemTwo: parseInt(e?.target.value) })}
            />
        </div>

        {err
            && <div className='CallParamsContainer'>
                <br />Error:
                <br />
                <div className='redFrame'>
                    {err}
                </div>
            </div>}
    </div>)
}